__webpack_require__.p = "/guest-website-frontend@v1-10-23/_next/";